module.exports = __webpack_public_path__ + "b69de1963007a0f2c3cc70bcab8e639c.png";